// extracted by mini-css-extract-plugin
export default {"LoginPanelContainer":"tWduWDrW"};